import type { StaffDetail } from "@/api/guide";

interface StatsBarProps {
  guide: StaffDetail;
}

export default function StatsBar({ guide }: StatsBarProps) {
  return (
    <div className="mx-4 px-4 py-3 rounded-2xl" style={{ marginTop: "1.5rem", background: "rgba(255,255,255,0.06)" }}>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-white" style={{ opacity: 0.5 }}>关注</span>
          <span className="text-base font-bold text-white">{guide.stats.following}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-white" style={{ opacity: 0.5 }}>粉丝</span>
          <span className="text-base font-bold text-white">{guide.collectCount}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-white" style={{ opacity: 0.5 }}>已服务</span>
          <span className="text-base font-bold text-white">{guide.stats.servedCount}</span>
        </div>
      </div>
      <div className="flex items-center gap-1.5 mt-2">
        <span className="text-xs text-white" style={{ opacity: 0.5 }}>所在城市</span>
        <span className="text-sm font-semibold text-white">{guide.city || "未知"}</span>
      </div>
    </div>
  );
}
